module.exports = __webpack_public_path__ + "static/media/pan2Question.11e68010.png";